<template>
  <section>

    <!-- Componentes externos -->
    <Reporte />
    <h3 class="primary--text">
      <v-icon color="primary">stop</v-icon> Seguimiento Observaciones
    </h3>
    
    <v-card>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
       <v-card-text>
   
          <!-- Template injectable de la cabecera de la tabla -->
          <template >
          <!-- <v-card-actions>
            <div>
             <h4 class="primary--text"
            >Seguimiento Observaciones </h4>
            </div>
            &nbsp;
            &nbsp;
          <div>
          
              <v-btn
                icon
                color="red"
                dark
                title="Generar reporte PDF"
                 @click="reporte()"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>

          </div>  
          </v-card-actions>     -->

            <p class="text-justify">
              
            </p>
            <v-card-text>
			<h2><strong>Detalle observación</strong></h2>
			<v-layout>
						<v-flex xs12> 
							<v-data-table
								:items="seguimiento_observacion"
								class="elevation-1"
								hide-actions
                noDataText="No hay resultados"
								:headers="headers_detalle"
							>
								<template v-slot:items="props">
							<td class="text-xs-center">{{ props.item.fec_creado }} </td>
              <td class="text-xs-center">{{ props.item.estado }} </td>
							<td class="text-xs-center">{{ props.item.observacion }}</td>
							<td class="text-xs-center">{{ props.item.funcionario }}</td>

									
								</template>
							</v-data-table>
						</v-flex>
					</v-layout>			
			</v-card-text>
         <!-- <v-flex xs6 sm3 v-if="estado==1" >
            <v-checkbox
              v-model="form.id_parametro_ta"
              label="Acepto"
              value="Acepto"
              :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
            ></v-checkbox>
          </v-flex>
        <v-card-actions>
          
          
          
              <v-spacer></v-spacer>
              <v-btn
                v-if="estado==1" 
                color="primary"
                type="submit"
                :loading="loading"
                :disabled="!valid"
              >
              <v-icon dark>check</v-icon> Finalizar
              </v-btn>
        </v-card-actions> -->
          
          </template>

          <!-- Template de filas y columnas -->
          
        
       </v-card-text>
      </v-form>
    </v-card>
   
  </section>
</template>
<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import Reporte from "../dialogs/Reporte"

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      estado:[],
      seguimiento_observacion:[],
      headers_detalle: [
				{
					text: 'Fecha',
					sortable: false,
					align: 'center'
				},
        {
					text: 'Estado',
					sortable: false,
					align: 'center'
				},
				{
					text: 'Observación',
					sortable: false,
					align: 'center'
				},
				{
					text: 'Usuario',
					sortable: false,
					align: 'center'
				}
				
			],
    };
  },
  mounted() {
   this.obtenerEstadoFicha();
   this.obtenerObservacion();
  },
  methods: 
  {
      async save() {
        //console.log('Finalizar::::::::::::::::::')
      let id_per
      let user = this.$storage.get("user");
    
      if (this.$refs.form.validate()) {
        this.loading = true;
          
          if(this.$route.params.id!=null){
            let id
             let a = this.$route.params.id; 
             id_per=a;
          }else{
              const user = this.$storage.get("user");
              let b = user.id_persona;
              id_per=b
          } 

          // console.log(id_per)
          // console.log(user.id)

        try {
          this.loading = true
					let res = await this.$service.graphql({
						query:`query{
                runQuery(consulta:"select persona.fn_estadoficha(${id_per},${user.id},37,'')"){
                  respuesta
                }
              }
						`,
					})
					if(res.runQuery.respuesta[0].fn_estadoficha===1){
						
						this.$message.success()
						
					}else{
            this.$message.error('Ocurrió un error en la operación')
          }
          this.loading = false
          
        } catch (error) {
          console.log(error);
        }
        
        //this.$message.success();
        this.loading = false;
        location.reload()
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
    async obtenerObservacion () {
		
      let id_per
      
     if(this.$route.params.id!=null){
            let id
             let a = this.$route.params.id; 
             id_per=a;
          }else{
              const user = this.$storage.get("user");
              let b = user.id_persona;
              id_per=b
          } 
		
      try {
          let res = await this.$service.graphql({
            query: `
              query{
                
                vSeguimientoObservas(id_persona: ${id_per}, id_estado: 40){
							rows{
								id
						id_persona
						observacion
						id_estado
						fec_creado
						_user_created
						nombre_persona
						funcionario
						estado      
							}
						}
					}	
            `
          })
          this.seguimiento_observacion = res.vSeguimientoObservas.rows;
          //console.log(this.seguimiento_observacion)
        } catch (error) {
          console.log(error)
        }
    },
    reporte(){
      let user = this.$storage.get("user");
      //console.log("Id persona ",user.id_persona);
      let id =0
      if(this.$route.params.id!=null){
             let a = this.$route.params.id; 
             id=a;
          }else{
              const user = this.$storage.get("user");
              let b = user.id_persona;
              id=b
          }
      let url = process.env.REPORTE_URL+id
      this.$bus.$emit('openDialogReporte', url)
      // this.guardarDocumento(url)
    },
     
  },
  components: {
    
    Reporte
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/Observaciones.vue